export default __webpack_public_path__ + "static/media/grid-dark.e085e61d.svg";